module.exports = __webpack_public_path__ + "static/img/file-pdf.0d99a2a1.svg";